import { ChallengeSettings } from "@/model/ChallengeSettings.model";
import { IFileModel } from "@/model/FileModel.model";
import { Game } from "@/model/Game.model";
import { User } from "@/model/User.model";
import { GetterTree } from "vuex";
import { State } from "./state";

// Getter types
export type Getters = {
  getCurrentUser(state: State): User;
  getGameSelected(state: State): Game;
  filterGame(state: State): Game[];
  searchGame(state: State): Game[];
  getListGames(state: State): Game[];
  getSettingChallenges(state: State): ChallengeSettings[];
  getChallengeSettingSelected(state: State): ChallengeSettings;
  getListFilesUpload(state: State): IFileModel[];
  getMyChallenge(state: State): Game[];
};

export const getters: GetterTree<State, State> & Getters = {
  getCurrentUser: state => {
    return state.user;
  },
  getGameSelected: state => {
    return state.gameSelected;
  },
  searchGame: state => {
    return state.games.filter(g =>
      g.name.toLocaleLowerCase().includes(state.searchGame.toLocaleLowerCase())
    );
  },
  filterGame: (state: State) => {
    const filterKey = state.filterGame;
    if (filterKey.length === 0) {
      return getters.searchGame(state);
    }
    return getters.searchGame(state).filter((g: Game) => {
      const check = filterKey.some(key => key === g.length || key === g.tag);
      if (check) {
        return g;
      }
    });
  },
  getListGames: state => {
    return state.games;
  },
  getSettingChallenges: state => {
    return state.challengeSettings;
  },
  getChallengeSettingSelected: state => {
    return state.challengeSettingSelected;
  },
  getListFilesUpload: state => {
    return state.fileAwaitUpload;
  },
  getMyChallenge: state => {
    const currentUser = state.user;
    return state.games.filter(game => {
      return game.creator?.uid === currentUser.uid;
    })
  }
};
